module.exports = __webpack_public_path__ + "img/RedBag_icon.90fa117.svg";